import Styles from './HandbookSettings.module.scss'
import { Button } from 'components/Button/Button'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { DeleteHandbookProps } from './Types'
import { Trash } from 'almanac-ui/icons'
import { Modal } from 'almanac-ui/Modal'
import { useDeleteProject } from 'hooks/useDeleteProject'
import { FolderMenuFile } from 'components/FolderMenu/Types'

const DeleteHandbook = ({ handbook }: DeleteHandbookProps) => {
  const { folder } = handbook
  const disabled = !!folder?.default_project
  const { deleteProject } = useDeleteProject({
    folderKey: folder?.key || '',
    almanac_file: folder?.almanac_file as FolderMenuFile,
  })
  if (!folder) return null

  return (
    <>
      <Modal.Content>
        <div className={Styles.deleteHandbook}>
          <div className={Styles.subLabel}>The project and all its documents will be deleted from the workspace</div>

          <Tooltip
            placement="bottom-start"
            label="This default project cannot be deleted"
            tooltipState={{ isOpen: disabled }}
          >
            <div>
              <Button variant="secondary" size="md" onPress={deleteProject} isDisabled={disabled} frontIcon={Trash}>
                Delete Project
              </Button>
            </div>
          </Tooltip>
        </div>
      </Modal.Content>
    </>
  )
}

export { DeleteHandbook }
